import React from "react";
import { cn } from "../../lib/utils";

const variantClasses = {
  primary: "bg-blue-600 text-white hover:bg-blue-700",
  success: "bg-green-600 text-white hover:bg-green-700",
  danger: "bg-red-500 text-white hover:bg-red-600",
  ghost: "hover:bg-gray-100 text-gray-700",
  warning: "bg-amber-500 text-white hover:bg-amber-600",
};

const variantStyles = {
  primary: {
    background: "#2563eb",
    color: "#ffffff",
  },
  success: {
    background: "#16a34a",
    color: "#ffffff",
  },
  danger: {
    background: "#ef4444",
    color: "#ffffff",
  },
  ghost: {
    background: "#f8fafc",
    color: "#334155",
    boxShadow: "inset 0 0 0 1px rgba(148,163,184,0.25)",
  },
  warning: {
    background: "#f97316",
    color: "#ffffff",
  },
};

export default function Button({
  children,
  icon: Icon,
  variant = "primary",
  className,
  style,
  disabled,
  type = "button",
  ...props
}) {
  const baseClass =
    "inline-flex items-center gap-2 rounded-lg px-4 py-2 text-sm transition";

  return (
    <button
      type={type}
      className={cn(baseClass, variantClasses[variant], className)}
      disabled={disabled}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        alignSelf: "flex-start",
        justifySelf: "start",
        flex: "0 0 auto",
        width: "auto",
        maxWidth: "100%",
        gap: 8,
        padding: "10px 16px",
        borderRadius: 12,
        border: "none",
        cursor: disabled ? "not-allowed" : "pointer",
        fontSize: 14,
        fontWeight: 600,
        lineHeight: 1,
        whiteSpace: "nowrap",
        transition: "background-color 0.2s ease, opacity 0.2s ease",
        opacity: disabled ? 0.6 : 1,
        ...variantStyles[variant],
        ...style,
      }}
      {...props}
    >
      {Icon ? <Icon size={16} strokeWidth={2} /> : null}
      <span>{children}</span>
    </button>
  );
}
